const waitForUtag = (callback1: () => void, callback2?: () => void) => {
  const maxAttempts = 20; // Set a maximum number of attempts
  let attempts = 0; // Track the number of checks

  const interval = setInterval(() => {
    if (
      typeof window.utag !== 'undefined' &&
      typeof window.utag.view === 'function'
    ) {
      clearInterval(interval);
      callback1();
      if (callback2 instanceof Function) {
        callback2();
      }
    } else if (attempts >= maxAttempts) {
      clearInterval(interval);
      // eslint-disable-next-line no-console
      console.error('Timed out waiting for utag.js');
    }

    attempts += 1;
  }, 500); // Check every half second
};

export {
  waitForUtag
};